import React from "react";
import UploadHeader from "../components/common/UploadHeader";
import ProductUpdateForm from "../components/productUpdate";

const ProductUpdate = () => {
  return (
    <>
      <UploadHeader />
      <ProductUpdateForm />
    </>
  );
};

export default ProductUpdate;
